import React, { useState,useEffect} from 'react';
import {Row,Col,ListGroup, Image, Button, Card,Form, Container} from 'react-bootstrap';
import { useNavigate,Link,useParams } from 'react-router-dom';
import { FaTruck, FaCreditCard, FaCheckCircle } from 'react-icons/fa';
import Message from '../components/Message';
import Loader from '../components/Loader';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import CheckoutStatusBar1 from '../components/CheckoutStatusBar1.jsx';
import { useGetOrderDetailsQuery} from '../slices/ordersApiSlice';
import { saveCreditCard } from '../slices/cartSlice'
import { clearCartItems} from '../slices/cartSlice';
import { useSelector, useDispatch  } from 'react-redux';
import accounting from 'accounting-js'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css'


const Completed = () => {
    const {id: orderId} =useParams();
    const {data: order,refetch, isLoading, error} = useGetOrderDetailsQuery(orderId);



    const {userInfo} = useSelector((state)=>state.auth);
    const [tempOrder,setTempOrder] = useState(order);
    const [orderItems,setOrderItems] = useState();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const[trig,setTrig] = useState();







useEffect(() => {
    if (order) {
        setTempOrder(order);
        setOrderItems(order.orderItems);
        dispatch(clearCartItems());
        dispatch(saveCreditCard({}));
        localStorage.removeItem('cart');



    }

  }, [order,isLoading]);


  const homeScreen = () => {
    navigate('/');

  }

  return (isLoading ) ? (
  <Loader />
  ) : error ? (
  <Message variant="danger" />
  ) : ((tempOrder) &&
    <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
      <Container>
        {userInfo ? <CheckoutStatusBar1 step4 locked /> : <CheckoutStatusBar userfill step4 locked />}
        <Row style={{ marginTop: '-20px' }}>
          <Col xs={12} md={8}>
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4"
              style={{
                borderTop: '4px solid #004488',
                marginTop: '40px',
                position: 'relative',
                zIndex: 0
              }}>
              <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
                <h4 className="m-0 fw-bold fs-5">Sipariş No: {tempOrder._id}</h4>
              </Card.Header>
              <ListGroup variant='flush'>

                {/* SEVKİYAT VE KARGO */}
                <ListGroup.Item className="p-4 border-bottom">
                  <h5 className="fw-bold mb-3 text-dark"><FaTruck className="me-2 text-muted" /> Sevkiyat ve Kargo</h5>
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="small text-muted mb-1">Teslimat Adresi:</div>
                      <p className="mb-0 fw-bold">{tempOrder.shippingAddress.receiver}</p>
                      <p className="small mb-0">{tempOrder.shippingAddress.address}, {tempOrder.shippingAddress.city} / {tempOrder.shippingAddress.state}</p>
                      <p className="small mb-0 mt-1"><strong>E-Posta:</strong> {tempOrder.shippingAddress.email}</p>
                    </Col>
                    <Col xs={12} sm={6} className="mt-3 mt-sm-0 border-start ps-4">
                      <div className="small text-muted mb-1">Seçilen Kargo:</div>
                      <div className="d-flex align-items-center gap-2">
                        {(tempOrder.shippingAddress.cargoSelection==='Yurtiçi Kargo')?(<img src='/images/yurtici.jpg' height="40" alt="Yurtiçi" />):(tempOrder.shippingAddress.cargoSelection==='Aras Kargo' ?(<img src='/images/aras.jpg' height="40" alt="Aras" />):(<img src='/images/mng.jpg' height="40" alt="MNG" />))}
                        <span className="fw-bold small" style={{ color: '#0a5c2b' }}>Ücretsiz Kargo</span>
                      </div>
                      {tempOrder.isPaid&&(tempOrder.isDelivered ?(
                        <Message variant='success'>
                          Kargoya verildi {tempOrder.deliveredAt +" Kargo Takip No: "+ tempOrder.deliverNumber}
                        </Message>
                      ):(
                        <Message variant='danger'>Henüz Kargoya verilmedi</Message>
                      ))}
                    </Col>
                  </Row>
                </ListGroup.Item>

                {/* ÖDEME DETAYLARI */}
                <ListGroup.Item className="p-4 border-bottom">
                  <h5 className="fw-bold mb-3 text-dark"><FaCreditCard className="me-2 text-muted" /> Ödeme Detayları</h5>
                  <p className="mb-2"><strong>Yöntem:</strong> {tempOrder.paymentMethod==="Banka Transferi" ? ('Banka Transferi'):('Kredi Kartı')}</p>
                  {tempOrder.paymentMethod === "Banka Transferi" ? (
                    <div className="p-3 bg-light border border-secondary-subtle rounded-3 small shadow-inner">
                      <strong className="d-block mb-1" style={{ color: '#004488' }}>ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. VE TİC. LTD. ŞTİ.</strong>
                      <div>Kuveyt Türk Katılım Bankası-Fikirtepe Şubesi</div>
                      <div>TRY IBAN: TR82 0020 5000 0977 1989 0000 02</div>
                    </div>
                  ) : ( tempOrder.isPaid &&
                    <div className="bg-light p-3 border rounded d-inline-block">
                      <Cards
                        cvc={''}
                        expiry={''}
                        name={''}
                        number={tempOrder.paymentResult.id}
                      />
                    </div>
                  )}
                  {tempOrder.isPaid ? (
                    <Message variant='success' className="mt-3">
                      Ödendi {tempOrder.paidAt}
                    </Message>
                  ):(
                    <Message variant='danger' className="mt-3">Henüz ödenmedi</Message>
                  )}
                </ListGroup.Item>

                {/* ÜRÜN LİSTESİ */}
                <ListGroup.Item className="p-4">
                  <h5 className="fw-bold mb-3 text-dark">Ürün Listesi</h5>
                  <ListGroup variant='flush' className="border rounded-3">
                    { tempOrder.orderItems.map((item,index) =>(
                      <ListGroup.Item key={index} className="py-3">
                        <Row className="align-items-center">
                          <Col xs={2} sm={1}><Image src={item.image} alt={item.name} fluid rounded className="border p-1 bg-white" /></Col>
                          <Col xs={10} sm={6}>
                            <Link to={`/product/${item.product}`} className="fw-bold text-dark small d-block text-decoration-none">
                              {item.name}
                            </Link>
                          </Col>
                          {((tempOrder.isOffered=== true && item.priceShow === false) || trig === true || item.priceShow === true )?
                          <Col xs={12} sm={5} className="text-sm-end fw-bold font-monospace text-secondary" style={{ fontSize: '0.85rem' }}>
                            { (trig=== true & !tempOrder.isOffered) && (<input disabled={item.priceShow  === true} name={item._id} type="number" className="form-control form-control-sm mb-1" onChange={(e)=> { setTempOrder({...tempOrder,  orderItems:[...tempOrder.orderItems.map(product=>{
                              if(product===item && product.priceShow===false) return  {...product,  price : parseFloat(e.target.value,2) }
                              else{
                                return  (product);
                              }
                            })]});

                            } }/>) }
                            {item.qty} x {accounting.formatMoney(item.price - (item.price * (item.discount || 0) / 100),{ symbol: "₺" })} = {accounting.formatMoney(item.qty * (item.price - (item.price * (item.discount || 0) / 100)),{ symbol: "₺" })}
                          </Col>
                           :
                           <Col xs={12} sm={5} className="text-sm-end">
                             <span className="badge bg-warning text-dark">Teklif Bekleniyor</span>
                           </Col>
                          }
                        </Row>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>

          {/* SAĞ KOLON: ÖZET VE DURUM */}
          <Col xs={12} md={4} className="mt-4 mt-md-0">
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4"
              style={{
                borderTop: '4px solid #004488',
                marginTop: '40px',
                position: 'relative',
                zIndex: 0
              }}>
              <Card.Header className="bg-dark text-white p-3 border-0"><h5 className="m-0 fw-bold">Sipariş Özeti</h5></Card.Header>
              <ListGroup variant='flush'>
                <ListGroup.Item className="p-3">
                  {(order.isOffered=== true || trig === true) ? (
                    <>
                      <div className="d-flex justify-content-between mb-1 small"><span>Ara Toplam:</span> <strong>{accounting.formatMoney(tempOrder.itemsPrice,{ symbol: "₺" })}</strong></div>
                      <div className="d-flex justify-content-between mb-2 small"><span>KDV (%20):</span> <strong>{accounting.formatMoney(tempOrder.taxPrice,{ symbol: "₺" })}</strong></div>
                      <hr className="my-2" />
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold">Toplam:</span>
                        <span className="text-primary fw-bold fs-5">{accounting.formatMoney(tempOrder.totalPrice,{ symbol: "₺" })}</span>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-muted fw-bold py-2">Teklif Bekleniyor</div>
                  )}
                </ListGroup.Item>

                <ListGroup.Item className="p-3 bg-light border-0">
                  {error && (
                    <Message variant='danger'>{error.data.message}</Message>
                  )}

                  {!error && (
                    <Message variant='success' className="d-flex align-items-start gap-2">
                      <FaCheckCircle className="mt-1 flex-shrink-0" />
                      <span>{ tempOrder.isPaid ?('Ödemeniz Alındı. Siparişinizin durumunu gelen emailinizden takip edebilirsiniz.'):( !tempOrder.isOffered ? ('Teklif İsteği Gönderildi. email adresine en kısa zamanda fiyat teklifi iletilecektir.'):('Sipariş isteği başarı ile alındı. Emaile gelen siparişinizi başlatın'))}</span>
                    </Message>
                  )}

                  <Button
                    className='w-100 border-0 fw-bold transition-all shadow-sm mt-2'
                    style={{ backgroundColor: '#2b2b2b', color: '#fff', height: '46px', borderRadius: '4px' }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                    onClick={homeScreen}
                  >
                    Markete Dön
                  </Button>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>

        </Row>
      </Container>
    </div>
  ) ;
}

export default Completed
